<div class="success-dialog">
  <button class="close-btn" mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="success-header">
    <div class="check-circle">
      <mat-icon>check</mat-icon>
    </div>
    <h2 class="title">Thanks! We've received your enquiry.</h2>
    <p class="subtitle">
      We will notify you about availability of the equipment at the earliest.
    </p>
  </div>

  <div class="booking-reference-section">
    <div class="label">BOOKING REFERENCE</div>
    <div class="reference-box" *ngFor="let id of bookingIds" (click)="copyToClipboard(id)">
      <div class="reference-id">{{ id }}</div>
      <div class="copy-hint">{{ copied ? 'Copied!' : 'Click to copy' }}</div>
    </div>
  </div>

  <div class="actions">
    <button class="notify-btn" (click)="goToNotifications()">
      Check notifications
    </button>
  </div>
</div>
